
import { defineComponent, reactive, toRefs, ref, onBeforeUnmount } from 'vue'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import VerificationHeader from './VerificationHeader.vue'
import AccountManageHeader from '../components/AccountManageHeader.vue'
import { AccountManageLoginService, err_ret_info, MsgYzmResponse } from '../components/loginApi.service'
import { ToastService } from '@/services/toast.service'
import { VERIFICATION_STATUS } from '../constants'

export default defineComponent({
  name: 'PhoneVerification',
  components: {
    VerificationHeader,
    AccountManageHeader
  },
  setup(_, { emit }) {
    const injector = useReflectiveInjector([AccountManageLoginService])
    const loginService = injector.get(AccountManageLoginService)
    const toast = injector.get(ToastService)

    const formData = reactive({
      phone: '',
      verificationCode: '',
    })

    const countdown = ref(0) // 倒计时秒数
    let countdownTimer: any = null

    // 组件卸载时清理定时器
    onBeforeUnmount(() => {
      clearCountdown()
    })

    function closeModal() {
      emit('close')
      clearCountdown()
    }

    /**
     * 验证手机号
     * @returns 验证通过返回 true，否则返回 false
     */
    function validatePhone(): boolean {
      if (!formData.phone) {
        toast.showToast({ message: '请输入手机号' })
        return false
      }

      const phoneReg = /^1[3-9]\d{9}$/
      if (!phoneReg.test(formData.phone)) {
        toast.showToast({ message: '请输入正确的手机号' })
        return false
      }

      return true
    }

    function confirm() {
      if (!validatePhone()) {
        return
      }
      if (!formData.verificationCode) {
        toast.showToast({ message: '请输入验证码' })
        return
      }
      emit('confirm', formData.verificationCode, formData.phone)
    }

    /**
     * 发送验证码
     */
    function sendVerificationCode() {
      if (!validatePhone()) {
        return
      }

      // 防止重复点击
      if (countdown.value > 0) {
        return
      }

      // 调用接口发送验证码
      loginService.requestGetMsgYzm({ phone_number: formData.phone })
        .then((res: MsgYzmResponse) => {
          if (res.status === VERIFICATION_STATUS.FAILED) {
            toast.showToast({ message: res.message })
          } else if (res.status === VERIFICATION_STATUS.SUCCESS) {
            toast.showToast({ message: res.message })
            // 使用接口返回的倒计时秒数，默认 60 秒
            const countdownTime = res.next_allow_sec || 60
            startCountdown(countdownTime)
          }
        })
        .catch((err) => {
          if (err.responseCommon.ret === err_ret_info.often) {
            toast.showToast({ message: '发送过于频繁，请稍后再试' })
          } else if (err.responseCommon.ret === err_ret_info.max) {
            toast.showToast({ message: '已达到今日最大发送次数' })
          } else {
            toast.showToast({ message: err.msg || '发送失败，请重试' })
          }
        })
    }

    /**
     * 开始倒计时
     * @param seconds 倒计时秒数
     */
    function startCountdown(seconds = 60) {
      countdown.value = seconds
      countdownTimer = setInterval(() => {
        countdown.value--
        if (countdown.value <= 0) {
          clearCountdown()
        }
      }, 1000)
    }

    /**
     * 清除倒计时
     */
    function clearCountdown() {
      if (countdownTimer) {
        clearInterval(countdownTimer)
        countdownTimer = null
      }
      countdown.value = 0
    }

    return {
      ...toRefs(formData),
      countdown,
      closeModal,
      confirm,
      sendVerificationCode
    }
  }
})
